import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import { getUserTenancy, tenancies } from "@/core/types/TenantTypes";
import bviVerification from "../components/verification/bviVerification.vue";
import jpVerification from "../components/verification/jpVerification.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'UsersVerifications',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_unref(getUserTenancy)() === _unref(tenancies).jp)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(jpVerification)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createVNode(bviVerification)
      ]))
}
}

})